import React, { useState, useEffect, useMemo, useRef } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios"; // For API calls
import Styles from "../../assets/css/SideComponents/BlogsSidebar.module.css";
import { useGlobalState } from "../../Functions/GlobalStates";

const BlogsSidebar = (props) => {
  const [userRating, setUserRating] = useState(0);
  const [averageRating, setAverageRating] = useState(5);
  const [hasRated, setHasRated] = useState(false);
  const [error, setError] = useState("");
  const [isWithinRange, setIsWithinRange] = useState(false);
  // React useRefs Referrences.
  const currentWidthHeight = useRef({ height: 0 });
  const AllcurrentWidthHeight = useRef({ height: 0 });
  const localStorageValue = useRef(
    localStorage.getItem("userRating") !== null // true if data exists, false otherwise
  );
  // GLOBAL STATES Here
  const {
    DropMenu,
    setDropMenuVisibility,
    PagesWidthHeight,
    setPagesWidthHeight,
    AllPagesWidthHeight,
    setAllPagesWidthHeight,
  } = useGlobalState();

  useEffect(() => {
    const UpdateWidthHeightSidebar = () => {
      const newHeight = PagesWidthHeight.height; // Get PagesHeight
      const AllnewHeight = AllPagesWidthHeight.height; // Get AllPagesHeight

      if (currentWidthHeight.current.height !== newHeight) {
        currentWidthHeight.current.height = newHeight;

        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(newHeight.toFixed(1)),
        }));
      }

      if (AllcurrentWidthHeight.current.height !== AllnewHeight) {
        AllcurrentWidthHeight.current.height = AllnewHeight;

        setAllPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(AllnewHeight.toFixed(1)),
        }));
      }
    };

    UpdateWidthHeightSidebar(); // Initial run
    window.addEventListener("resize", UpdateWidthHeightSidebar);

    return () => {
      window.removeEventListener("resize", UpdateWidthHeightSidebar);
    };
  }, []); // only on mount

  // Toggle Sidebar States Management Here
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 0 && width <= 800) {
        setIsWithinRange(true); // Update state when width is within range
      } else {
        setIsWithinRange(false); // Update state when width is out of range
        setDropMenuVisibility(true); // Show DropMenu for larger screens
      }
    };

    // Call the function initially to set the state based on the current width
    handleResize();

    // Add the resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Reset Sidebar States On Route Change and mount Here
  useEffect(() => {
    const width = window.innerWidth;
    if (width >= 0 && width <= 800) {
      setDropMenuVisibility(false); // Hide Sidebar on Route Change for smaller screens only
    }
    console.log("DropMenu is :", DropMenu);
  }, []);

  useEffect(() => {
    const fetchRatings = async () => {
      try {
        const response = await axios.get(
          "https://affiliators.netlify.app/.netlify/functions/server/api/ratings"
        ); // Fetch ratings from backend
        setAverageRating(response.data.averageRating || averageRating);

        const savedRating = localStorage.getItem("userRating");
        if (savedRating) {
          setUserRating(Number(savedRating));
          setHasRated(true);
        }
      } catch (error) {
        console.error("Error fetching ratings:", error.message);
        setError("Failed to load ratings. Please try again later.");
      }
    };

    fetchRatings();
  }, []); // only once on mount

  const handleRating = async (newRating) => {
    if (!localStorageValue.current) {
      setUserRating(newRating);
      try {
        // Submit the new rating
        const submitResponse = await axios.post(
          "https://affiliators.netlify.app/.netlify/functions/server/api/ratings",
          { rating: newRating },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setAverageRating(submitResponse.data.updatedAverage || averageRating);

        // Save the user's rating to localStorage
        localStorage.setItem("userRating", newRating);
        setUserRating(Number(newRating));
        setHasRated(true);
      } catch (error) {
        console.error("Error submitting rating:", error.message);
      }
    }
  };

  // This function returns stars that then presented in the next return
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => {
      const fillPercentage = Math.min(Math.max(rating - index, 0), 1) * 100; // Calculate fill percentage for each star

      return (
        <span
          key={index}
          style={{
            position: "relative",
            color: "#ccc",
          }}
        >
          <span
            style={{
              position: "absolute",
              color: "#ffd700",
              overflow: "hidden",
              clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`, // Clip the star based on the percentage filled
            }}
          >
            ★
          </span>
          ★
        </span>
      );
    });
  };

  const renderedDropMenu = useMemo(() => {
    if (!DropMenu) return null;
    if (DropMenu && !isWithinRange) {
      return (
        <>
          <div
            style={{
              height: isWithinRange
                ? `${AllPagesWidthHeight.height}px`
                : `${PagesWidthHeight.height}px`,
            }}
            className={Styles.BlogsSidebarContainerWrapper}
          >
            <div
              onClick={(e) => {
                if (!isWithinRange) {
                  null;
                } else {
                  e.stopPropagation();
                }
              }}
              className={`${Styles.BlogsSidebarContainer} ${DropMenu ? Styles.BlogsSidebarActiveContainer : ""
                }`}
            >
              <section className={Styles.BlogsSidebarSection1}>
                <div className={Styles.BlogsSidebarSection1CategoryContainer}>
                  <h1>PROBLEM SOLVING</h1>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/npmerrors"
                  >
                    Npm Errors
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/slowlaptop"
                  >
                    Slow Laptop
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/hostingdomainsolution"
                  >
                    Hosting Domain Solution
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/mobileresponsiveness"
                  >
                    Mobile Responsiveness
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/ecommercesolutions"
                  >
                    E-Commerce Solutions
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/securitysolutions"
                  >
                    Security Solutions
                  </NavLink>
                </div>
                <div
                  className={Styles.BlogsSidebarSection1RelatedTopicsContainer}
                >
                  <h1>RELATED TOPICS</h1>
                  <a
                    href={props.RTL1}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC1}
                  </a>
                  <a
                    href={props.RTL2}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC2}
                  </a>
                  <a
                    href={props.RTL3}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC3}
                  </a>
                  <a
                    href={props.RTL4}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC4}
                  </a>
                  <a
                    href={props.RTL5}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC5}
                  </a>
                  <a
                    href={props.RTL6}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC6}
                  </a>
                </div>
              </section>

              {/* Rating Section */}
              <section className={Styles.BlogsSidebarSection2RatingsContainer}>
                {error && (
                  <div style={{ color: "red" }} className={Styles.ErrorMessage}>
                    {error}
                  </div>
                )}
                {!hasRated ? (
                  <>
                    <div
                      className={
                        Styles.BlogsSidebarSection2RatingsStarsGrayContainer
                      }
                    >
                      <h2>Rate This Blog</h2>
                      <div
                        className={
                          Styles.BlogsSidebarSection2GrayStarsContainer
                        }
                      >
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span
                            key={star}
                            onClick={() => handleRating(star)}
                            style={{
                              color: star <= userRating ? "#ffd700" : "#ccc", // Highlight stars
                            }}
                            // Hover effect to show highlighted stars
                            onMouseEnter={() => setUserRating(star)}
                            onMouseLeave={() => !hasRated && setUserRating(0)}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                      <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                    </div>
                  </>
                ) : (
                  <div
                    className={
                      Styles.BlogsSidebarSection2ThanksUserRatingsContainer
                    }
                  >
                    <p style={{ color: "black" }}>
                      Your Rating: &nbsp;
                      <span style={{ color: "red" }}>{userRating} Stars</span>
                    </p>
                    <p style={{ color: "black" }}>Thank you for rating Us💖</p>
                  </div>
                )}

                {/* Show average rating after user has submitted their rating */}
                {hasRated && (
                  <>
                    <div
                      className={
                        Styles.BlogsSidebarSection2AllUsersRatingsStarsContainer
                      }
                    >
                      <div
                        className={
                          Styles.BlogsSidebarSection2AllUsersStarsContainer
                        }
                      >
                        {renderStars(averageRating)}{" "}
                        {/* Display average rating with dynamic gradients */}
                      </div>
                      <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                    </div>
                  </>
                )}
              </section>
              {isWithinRange && (
                <section className={Styles.BlogsSidebarSection3Container}>
                  <div
                    className={Styles.BlogsSidebarSection3LinksHeadingContainer}
                  >
                    <div
                      className={Styles.BlogsSidebarSection3HeadingContainer}
                    >
                      <h1>SUPPORT PAGES</h1>
                    </div>
                    <div className={Styles.BlogsSidebarSection3LinksContainer}>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/services"
                        end
                      >
                        Services
                      </NavLink>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/privacy-policy"
                        end
                      >
                        Privacy Policy
                      </NavLink>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/customer-support"
                        end
                      >
                        &#9742; Customer Support &#x2764;
                      </NavLink>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </>
      );
    } else if (DropMenu && isWithinRange) {
      return (
        <>
          <div
            style={{
              height: isWithinRange
                ? `${AllPagesWidthHeight.height}px`
                : PagesWidthHeight.height,
            }}
            className={Styles.BlogsSidebarContainerWrapper}
          >
            <div
              onClick={(e) => {
                if (!isWithinRange) {
                  null;
                } else {
                  e.stopPropagation();
                }
              }}
              className={`${Styles.BlogsSidebarContainer} ${DropMenu ? Styles.BlogsSidebarActiveContainer : ""
                }`}
            >
              <section className={Styles.BlogsSidebarSection1}>
                <div className={Styles.BlogsSidebarSection1CategoryContainer}>
                  <h1>PROBLEM SOLVING</h1>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/npmerrors"
                  >
                    Npm Errors
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/slowlaptop"
                  >
                    Slow Laptop
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/hostingdomainsolution"
                  >
                    Hosting Domain Solution
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/mobileresponsiveness"
                  >
                    Mobile Responsiveness
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/ecommercesolutions"
                  >
                    E-Commerce Solutions
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? Styles.activeLink : Styles.inactiveLink
                    }
                    to="/problemsolving/securitysolutions"
                  >
                    Security Solutions
                  </NavLink>
                </div>
                <div
                  className={Styles.BlogsSidebarSection1RelatedTopicsContainer}
                >
                  <h1>RELATED TOPICS</h1>
                  <a
                    href={props.RTL1}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC1}
                  </a>
                  <a
                    href={props.RTL2}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC2}
                  </a>
                  <a
                    href={props.RTL3}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC3}
                  </a>
                  <a
                    href={props.RTL4}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC4}
                  </a>
                  <a
                    href={props.RTL5}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC5}
                  </a>
                  <a
                    href={props.RTL6}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.RTC6}
                  </a>
                </div>
              </section>

              {/* Rating Section */}
              <section className={Styles.BlogsSidebarSection2RatingsContainer}>
                {error && (
                  <div style={{ color: "red" }} className={Styles.ErrorMessage}>
                    {error}
                  </div>
                )}
                {!hasRated ? (
                  <>
                    <div
                      className={
                        Styles.BlogsSidebarSection2RatingsStarsGrayContainer
                      }
                    >
                      <h2>Rate This Blog</h2>
                      <div
                        className={
                          Styles.BlogsSidebarSection2GrayStarsContainer
                        }
                      >
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span
                            key={star}
                            onClick={() => handleRating(star)}
                            style={{
                              color: star <= userRating ? "#ffd700" : "#ccc", // Highlight stars
                            }}
                            // Hover effect to show highlighted stars
                            onMouseEnter={() => setUserRating(star)}
                            onMouseLeave={() => !hasRated && setUserRating(0)}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                      <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                    </div>
                  </>
                ) : (
                  <div
                    className={
                      Styles.BlogsSidebarSection2ThanksUserRatingsContainer
                    }
                  >
                    <p style={{ color: "black" }}>
                      Your Rating: &nbsp;
                      <span style={{ color: "red" }}>{userRating} Stars</span>
                    </p>
                    <p style={{ color: "black" }}>Thank you for rating Us💖</p>
                  </div>
                )}

                {/* Show average rating after user has submitted their rating */}
                {hasRated && (
                  <>
                    <div
                      className={
                        Styles.BlogsSidebarSection2AllUsersRatingsStarsContainer
                      }
                    >
                      <div
                        className={
                          Styles.BlogsSidebarSection2AllUsersStarsContainer
                        }
                      >
                        {renderStars(averageRating)}{" "}
                        {/* Display average rating with dynamic gradients */}
                      </div>
                      <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                    </div>
                  </>
                )}
              </section>
              {isWithinRange && (
                <section className={Styles.BlogsSidebarSection3Container}>
                  <div
                    className={Styles.BlogsSidebarSection3LinksHeadingContainer}
                  >
                    <div
                      className={Styles.BlogsSidebarSection3HeadingContainer}
                    >
                      <h1>SUPPORT PAGES</h1>
                    </div>
                    <div className={Styles.BlogsSidebarSection3LinksContainer}>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/services"
                        end
                      >
                        Services
                      </NavLink>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/privacy-policy"
                        end
                      >
                        Privacy Policy
                      </NavLink>
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? Styles.activeLink : Styles.inactiveLink
                        }
                        to="/customer-support"
                        end
                      >
                        &#9742; Customer Support &#x2764;
                      </NavLink>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  }, [
    DropMenu,
    isWithinRange,
    AllPagesWidthHeight,
    PagesWidthHeight,
    hasRated,
    userRating,
  ]); // dependency array helps run when value changes

  return <>{renderedDropMenu}</>;
};

export default BlogsSidebar;
